export const STANDARD_SHIPPING_49 = 'standard_shipping_49';
export const STANDARD_SHIPPING_9 = 'standard_shipping_9';
export const DELIVERY_AND_INSTALLATION = 'delivery_and_installation';
